var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInviteSentCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Livello_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 46.73 42.87"
    },
    xmlSpace: "preserve",
    viewBox: "9.81 9.8 23.25 23.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69389",
    transform: "translate(1196.725 111.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37233",
    style: {
      stroke: "#000000",
      strokeWidth: 0.4
    },
    d: "M-1186.72-82.78v-13.75c0.04-0.2,0.07-0.39,0.11-0.59c0.48-2.32,2.54-3.98,4.9-3.96   c4.28-0.01,8.55-0.01,12.83,0c1.03-0.01,2.05,0.31,2.88,0.91c1.37,0.94,2.17,2.52,2.12,4.18c0.01,4.22,0.01,8.43,0,12.65   c0,0.1,0,0.21-0.01,0.31c-0.08,2.03-1.39,3.8-3.3,4.48c-0.41,0.12-0.83,0.23-1.25,0.31h-13.74c-0.06-0.01-0.13-0.03-0.19-0.04   c-1.85-0.22-3.42-1.48-4.04-3.24C-1186.54-81.93-1186.64-82.35-1186.72-82.78 M-1175.27-99.65c-2.14,0-4.27-0.01-6.4,0   c-1.96-0.04-3.58,1.52-3.62,3.49c0,0.03,0,0.06,0,0.09c-0.01,4.28-0.01,8.55,0,12.83c-0.02,1.96,1.55,3.56,3.51,3.58   c0.03,0,0.05,0,0.08,0c4.27,0.01,8.54,0.01,12.81,0c1.96,0.02,3.57-1.55,3.59-3.51c0-0.03,0-0.06,0-0.09   c0.01-4.26,0.01-8.52-0.01-12.78c0-0.4-0.07-0.8-0.19-1.18c-0.48-1.47-1.87-2.45-3.42-2.42   C-1171.03-99.65-1173.15-99.65-1175.27-99.65"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_148126",
    x: -1177.43,
    y: -95.35,
    style: {
      stroke: "#000000",
      strokeWidth: 0.4
    },
    width: 8.55,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_148127",
    x: -1177.43,
    y: -90.36,
    style: {
      stroke: "#000000",
      strokeWidth: 0.4
    },
    width: 8.54,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_148128",
    x: -1177.43,
    y: -85.35,
    style: {
      stroke: "#000000",
      strokeWidth: 0.4
    },
    width: 8.55,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37234",
    style: {
      stroke: "#000000",
      strokeWidth: 0.4
    },
    d: "M-1180.3-93.23c-0.24,0-0.48,0.01-0.71,0c-0.39,0.01-0.7-0.3-0.71-0.69   c0-0.01,0-0.01,0-0.02c-0.01-0.48-0.01-0.97,0-1.45c0-0.38,0.32-0.69,0.7-0.69c0.48-0.01,0.97-0.01,1.45,0   c0.38,0,0.7,0.31,0.7,0.69c0.01,0.49,0.01,0.98,0,1.47c-0.01,0.38-0.31,0.68-0.69,0.68C-1179.8-93.22-1180.05-93.23-1180.3-93.23   L-1180.3-93.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37235",
    style: {
      stroke: "#000000",
      strokeWidth: 0.4
    },
    d: "M-1180.3-88.23c-0.24,0-0.48,0.01-0.71,0c-0.39,0.01-0.7-0.3-0.71-0.69   c0-0.01,0-0.01,0-0.02c-0.01-0.48-0.01-0.95,0-1.43c-0.01-0.39,0.3-0.71,0.68-0.72c0.01,0,0.03,0,0.04,0c0.47-0.01,0.93-0.01,1.4,0   c0.39-0.01,0.71,0.29,0.72,0.68c0,0.01,0,0.03,0,0.04c0.01,0.47,0.01,0.93,0,1.4c0.01,0.39-0.3,0.72-0.69,0.73   c-0.02,0-0.03,0-0.05,0C-1179.84-88.23-1180.07-88.23-1180.3-88.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37236",
    style: {
      stroke: "#000000",
      strokeWidth: 0.4
    },
    d: "M-1178.87-84.66c0,0.24,0.01,0.48,0,0.71c0.01,0.39-0.3,0.7-0.69,0.71   c-0.01,0-0.01,0-0.02,0c-0.48,0.01-0.97,0.01-1.45,0c-0.38,0-0.69-0.32-0.69-0.7c-0.01-0.48-0.01-0.97,0-1.45   c0-0.38,0.31-0.7,0.69-0.7c0.49-0.01,0.98-0.01,1.47,0c0.38,0.01,0.68,0.31,0.68,0.69C-1178.86-85.15-1178.87-84.9-1178.87-84.66   L-1178.87-84.66z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteSentCropped);
export default __webpack_public_path__ + "static/media/invite-sent-cropped.958a493693a372f5d05433b024feb5e4.svg";
export { ForwardRef as ReactComponent };